"use client";

import {
  CampaignCard,
  BlogCard,
  BrandCard,
} from "@/components/featured/common";
import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";
import DynamicStats from "@/components/DynamicStats";
import RouteCard from "@/components/pages/ferry/cards/RouteCard";
import IconTextCard from "@/components/pages/ferry/cards/IconTextCard";
import ImageCardWrapper from "@/components/pages/bus/cards/ImageCardWrapper";
import FerryPopularLocations from "@/components/pages/ferry/FerryPopularLocations";
import AppBanner from "@/components/featured/common/banner/AppBanner";

export const componentRegistry = {
  OpportunitiesCardWrapper,
  CampaignCard,
  BlogCard,
  DynamicStats,
  RouteCard,
  IconText: IconTextCard,
  ImageCardWrapper,
  FerryPopularLocations,
  BrandCard,
  AppBanner,
};

export const itemPropMapping = {
  OpportunitiesCardWrapper: "item",
  CampaignCard: "item",
  BlogCard: "post",
  RouteCard: "item",
  IconText: "item",
  ImageCardWrapper: "item",
  BrandCard: "brand",
};
